<template>
  <div class="purchase-wrap">
    <el-card>
      <el-tabs v-model="activeTab">
        <el-tab-pane :label="$t('purchase::purchase-list::order')" name="list"></el-tab-pane>
        <el-tab-pane :label="$t('purchase::purchase-list::purchase_detail')" name="purchaseDetail" v-if="authPromise('purchase::purchase-list::check')"></el-tab-pane>
      </el-tabs>
    </el-card>
    <component :is="activeTab" style="margin-top: -32px"></component>
  </div>
</template>

<script>
import list from '../components/list'
import purchaseDetail from '../components/details'
export default {
  name: 'purchase-list',
  components: { list, purchaseDetail },
  data() {
    return {
      activeTab: 'list',
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped></style>
